export function removeIdFromQuery(query=""){
	let q = query
		.replace('?', '')
		.split('&')
		.filter(a => a)
		.map(e => e.split('='))
		.filter(([param, val]) =>
			param.toLowerCase() !== "id"
		)
		.map(pair => pair.join('='))
		.join('&');
	return q ? `?${q}` : "";
}

export function queryObj(query) {
   return query
      .replace('?', '')
      .split('&')
      .filter(a => a)
      .map(e => e.split('='))
      .reduce((prev, curr) => {
         prev[curr[0]] = curr[1];
         return prev;
      }, {});
}

export function idIntoQuery(query, id) {
   let q = removeIdFromQuery(query);
   return `${q}${!q ? '?' : '&'}id=${id}`;
}